/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Projects_Delete_Button_LabelInputs */



/**
* | output |
* | --- |
* | "Delete project {name}" |
*
* @param {Projects_Delete_Button_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_delete_button_label = /** @type {((inputs: Projects_Delete_Button_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Delete_Button_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Projekt ${i?.name} löschen`)
	return /** @type {LocalizedString} */ (`Delete project ${i?.name}`)
});